import { Box, Stack } from "@mui/material";
import { LazyImage } from "./LazyImage";
import React from "react";

export function OverlayedImage(props: {
  alt: string;
  src: string;
  width: number; // next js image width (actual width of the image)
  height: number; // next js image height (actual height of the image)
  children?: React.ReactNode;
  slot?: {
    overlay?: {
      style?: React.CSSProperties;
    };
    image?: {
      style?: React.CSSProperties;
    };
  };
}) {
  return (
    <Box width={"100%"} height={"100%"} position={"relative"}>
      <Box position={"absolute"} width={"100%"} height={"100%"} zIndex={1}>
        {props.children}
      </Box>

      <Box
        width={"100%"}
        height={"100%"}
        overflow={"hidden"}
        sx={{
          pointerEvents: "none",
          ...props.slot?.overlay?.style,
        }}
      >
        <LazyImage
          alt={`${props.alt}`}
          width={props.width}
          height={props.height}
          src={props.src}
          style={{
            objectFit: "cover",
            width: "100%",
            height: "100%",
            ...props.slot?.image?.style,
          }}
        />
      </Box>
    </Box>
  );
}
